/*******************************************************
BUILD SEARCH RESULT
Builds the HTML for a player search resultsHTML.
********************************************************/

export default function buildSearchResult(sport,playerObject) {
    const { link, logo, alt, name, span, text } = playerObject;

    // If viewing all sports, the default logo should be at least an empty div. Othwerise it can be empty
    const logoDefault = (sport == 'All') ? '<div class="search-result__logo"></div>' : '';
    const logoHTML = logo ? `<img class="search-result__logo" src="${logo}">` : logoDefault;

    // Specific handler for cases where the text is not set and thus we should not have any left-margins
    const spanStyle = text ? '' : 'style="padding-left:0px;"';

    return `
    <li class="search-result">
        <a class="search-result__link" href="${link}">
            ` + logoHTML + `
            <div class="search-result__main">
                <div class="search-result__name">${name}</div>
                    <div class="search-result__text">${text}<span class="search-result__span" ${spanStyle}>${span}</span></div>
            </div>
        </a>
    </li>`;
}
